import React from 'react';
import { Link } from 'react-router-dom';
import LikenessTake from '../components/builder/LikenessTake';
import { useAuth } from '../AuthContext';
import { useMyOrgRole, roleSatisfies } from '../data/entities';

const ORG = 'team';
const APP = 'X9Hqaux2ppbqUB6V6fnE';

// The usable recorder. App Builder stays the studio; this page is the app.
export default function LikenessPage() {
  const { user } = useAuth();
  const role = useMyOrgRole(ORG);
  if (role === undefined) return <div className="cs-page"><p className="cs-help">Loading…</p></div>;
  if (!role) {
    return (
      <div className="cs-page" style={{ maxWidth: 640 }}>
        <h1 style={{ fontSize: 28, marginTop: 0 }}>Likeness</h1>
        <p>{user?.email || 'This account'} is not on the team that owns this app.</p>
        <p><Link to="/login?next=/likeness">Sign in with the account that was added</Link></p>
      </div>
    );
  }
  return (
    <div className="cs-page" style={{ maxWidth: 960 }}>
      <h1 style={{ fontSize: 28, margin: '0 0 4px' }}>Likeness</h1>
      <p className="cs-help" style={{ marginTop: 0 }}>Record yourself. Voice, then face.</p>
      <LikenessTake org={{ id: ORG }} app={{ id: APP }} uid={user.uid} isAdmin={roleSatisfies(role, 'admin')} />
    </div>
  );
}
